<template>
  <vue-html2pdf
    :show-layout="false"
    :float-layout="true"
    :enable-download="false"
    :preview-modal="true"
    :manual-pagination="true"
    pdf-content-width="800px"
    ref="cv"
    :html-to-pdf-options="options"
  >
    <section slot="pdf-content">
      <v-app style="background-color: white !important">
        <v-container class="font white" style="background-color: white !important">
          <v-row>
            <v-col cols="12">
              <div class="text-h4 text-center" align="center">Curriculum Vitae</div>
            </v-col>
            <v-col cols="12">
              <v-row justify="end">
                <v-col v-if="photo" cols="auto">
                  <img :src="photo.src" crossOrigin="anonymous" width="160" height="160" />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <div class="text-h6 ml-6 text-center font-weight-bold" align="center">Datos Personales</div>
                  <div>
                    <strong>Nombre:</strong>
                    {{ personal ? personal.nombre + ' ' + personal.apaterno + ' ' + personal.amaterno : '' }}
                  </div>
                  <div>
                    <strong>Edad y Fecha de nacimiento:</strong>
                    {{
                      personal && personal.fechaNacimiento
                        ? getAge(personal.fechaNacimiento) + ' , ' + personal.fechaNacimiento
                        : ''
                    }}
                  </div>
                  <div>
                    <strong>Lugar de nacimiento:</strong>
                    {{
                      personal && personal.CatMunicipioNacimiento.nombre
                        ? personal.CatMunicipioNacimiento.nombre +
                          ' , ' +
                          personal.CatMunicipioNacimiento.catEstado.title
                        : ''
                    }}
                  </div>
                  <div>
                    <strong>Dirección:</strong>
                    {{
                      personal &&
                      personal.Contacto.Direccion.calle +
                        ' , ' +
                        personal.Contacto.Direccion.colonia +
                        ' , ' +
                        personal.Contacto.Direccion.ext +
                        ' , ' +
                        personal.Contacto.Direccion.cp
                    }}
                  </div>
                  <div><strong>Estado Civil:</strong> {{ personal ? personal.CatEstadoCivil.title : '' }}</div>
                  <div><strong>CURP:</strong> {{ personal ? personal.curp : '' }}</div>
                  <div><strong>RFC:</strong> {{ personal ? personal.rfc : '' }}</div>
                  <div><strong>CUIP:</strong> {{ personal ? personal.CUIP : '' }}</div>
                  <div><strong>CUP:</strong> {{ personal ? personal.CUP : 'N/A' }}</div>
                  <div>
                    <strong>Correo electrónico:</strong> {{ personal ? personal.Contacto.correoElectronico : '' }}
                  </div>
                  <div><strong>Numero Telefónico:</strong> {{ personal ? personal.Contacto.telefonoCelular : '' }}</div>
                  <div>
                    <strong>Numero de Matricula de Cartilla Militar:</strong>
                    {{ personal ? personal.cartillaMilitar : '' }}
                  </div>
                </v-col>
                <v-col cols="12">
                  <div class="text-h6 ml-6 text-center font-weight-bold" align="center">Trayectoria Educativa</div>
                  <div v-if="tieneTrayectoriaEducativa">
                    <div v-if="getPrimaria">
                      <div class="text-subtitle-1 font-weight-bold text-center" align="center">Primaria</div>
                      <div><strong>Nombre de la Institución:</strong> {{ getPrimaria.institucion }}</div>
                      <div><strong>Ciclo Escolar:</strong> {{ getPrimaria.generacion }}</div>
                      <div>
                        <strong>Documento Obtenido:</strong>
                        {{ getPrimaria.ComprobanteEstudio ? getPrimaria.ComprobanteEstudio.title : '' }}
                      </div>
                      <br />
                    </div>
                    <div v-if="getSecundaria">
                      <div class="text-subtitle-1 font-weight-bold text-center" align="center">Secundaria</div>
                      <div><strong>Nombre de la Institución:</strong> {{ getSecundaria.institucion }}</div>
                      <div><strong>Ciclo Escolar:</strong> {{ getSecundaria.generacion }}</div>
                      <div>
                        <strong>Documento Obtenido:</strong>
                        {{ getSecundaria.ComprobanteEstudio ? getSecundaria.ComprobanteEstudio.title : '' }}
                      </div>
                      <br />
                    </div>
                    <div v-if="getBachillerato">
                      <div class="text-subtitle-1 font-weight-bold text-center" align="center">Bachillerato</div>
                      <div><strong>Nombre de la Institución:</strong> {{ getBachillerato.institucion }}</div>
                      <div><strong>Ciclo Escolar:</strong> {{ getBachillerato.generacion }}</div>
                      <div>
                        <strong>Documento Obtenido:</strong>
                        {{ getBachillerato.ComprobanteEstudio ? getBachillerato.ComprobanteEstudio.title : '' }}
                      </div>
                      <br />
                    </div>
                    <div v-if="getUniversidad">
                      <div class="text-subtitle-1 font-weight-bold text-center" align="center">Universidad</div>
                      <div><strong>Nombre de la Institución:</strong> {{ getUniversidad.institucion }}</div>
                      <div><strong>Ciclo Escolar:</strong> {{ getUniversidad.generacion }}</div>
                      <div>
                        <strong>Documento Obtenido:</strong>
                        {{ getUniversidad.ComprobanteEstudio ? getUniversidad.ComprobanteEstudio.title : '' }}
                      </div>
                      <br />
                    </div>
                  </div>
                  <div v-else>
                    <em>No hay trayectoria educativa registrada.</em>
                  </div>
                </v-col>
                <v-col cols="12">
                  <div class="text-h6 ml-6 text-center font-weight-bold" align="center">Trayectoria Laboral</div>
                  <div v-if="tieneTrayectoriaLaboral">
                    <div
                      v-for="(trayectoria, idx) in trayectoriasLaborales"
                      :key="trayectoria.idTrayectoriaLaboral || idx"
                      style="margin-bottom: 16px"
                    >
                      <div>
                        <strong>Nombre de la Empresa:</strong>
                        {{ trayectoria.empresa || trayectoria.nombreEmpresa || '-' }}
                      </div>
                      <div><strong>Puesto:</strong> {{ trayectoria.puesto || '-' }}</div>
                      <div><strong>Periodo:</strong> {{ trayectoria.periodo || '-' }}</div>
                      <div><strong>Motivo de Conclusión:</strong> {{ trayectoria.motivoConclusion || '-' }}</div>
                      <br />
                    </div>
                  </div>
                  <div v-else>
                    <em>No hay trayectoria laboral registrada.</em>
                  </div>
                </v-col>
                <v-col cols="12">
                  <div class="text-h6 ml-6 text-center font-weight-bold" align="center">Capacitación y/o cursos</div>
                  <div v-if="tieneCursos">
                    <div
                      v-for="(curso, idx) in cursosParaMostrar"
                      :key="curso.nombre + '-' + curso.fecha + '-' + idx"
                      style="margin-bottom: 16px"
                    >
                      <div><strong>Fecha:</strong> {{ curso.fecha }}</div>
                      <div><strong>Documento Obtenido:</strong></div>
                      <div><strong>Nombre del curso:</strong> {{ curso.nombre }}</div>
                      <br />
                    </div>
                  </div>
                  <div v-else>
                    <em>No hay cursos o capacitaciones registrados.</em>
                  </div>
                </v-col>
                <v-col cols="12">
                  <div class="text-h6 ml-6 text-center font-weight-bold" align="center">
                    Áreas de Adscripción en la S.S.C
                  </div>
                  <div v-if="permutaciones && permutaciones.length">
                    <div
                      v-for="(perm, idx) in permutaciones"
                      :key="perm.idPermutacion || idx"
                      style="margin-bottom: 16px"
                    >
                      <div><strong>Fecha:</strong> {{ perm.fecha }}</div>
                      <div><strong>Descripción:</strong> {{ perm.descripcion }}</div>
                      <br />
                    </div>
                  </div>
                  <div v-else>
                    <em>No hay áreas de adscripción registradas.</em>
                  </div>
                </v-col>
                <v-col cols="12">
                  <v-row justify="center">
                    <v-col cols="12" class="text-center">
                      <div
                        class="firma-centro"
                        style="border-bottom: 1.5px solid #333; width: 60%; margin: 0 auto 4px auto; height: 32px"
                      ></div>
                      <div class="firma-centro subtitle-2 font-weight-bold" style="margin: 0 auto; width: 60%">
                        Nombre y firma
                      </div>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-container>
      </v-app>
    </section>
  </vue-html2pdf>
</template>

<style scoped>
.bordered {
  border: 1px solid black;
}
.font {
  font-family: Arial, Helvetica, sans-serif;
  font-size: 14px;
  background-color: white !important;
}
.firma-centro {
  text-align: center;
  width: 60%;
  margin: 0 auto;
}
/* Forzar fondo blanco para el PDF */
::v-deep .v-application {
  background-color: white !important;
}
::v-deep .v-container {
  background-color: white !important;
}
::v-deep .v-row {
  background-color: white !important;
}
::v-deep .v-col {
  background-color: white !important;
}
::v-deep .white {
  background-color: white !important;
}
::v-deep .v-application--wrap {
  background-color: white !important;
}
::v-deep * {
  background-color: white !important;
}
</style>

<script>
import VueHtml2pdf from 'vue-html2pdf'
import { mapGetters } from 'vuex'

export default {
  components: {
    VueHtml2pdf,
  },
  props: {
    personal: {
      type: Object,
      required: true,
    },
    referencias: {
      type: Array,
    },
    cursos: {
      type: Array,
      default: () => [],
    },
    permutaciones: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      options: {
        filename: 'Curriculum',
        image: {
          type: 'jpeg',
          quality: 0.98,
        },
        html2canvas: {
          scale: 2,
          useCORS: true,
          allowTaint: false,
        },
        jsPDF: {
          unit: 'px',
          format: 'a4',
          orientation: 'portrait',
          hotfixes: ['px_scaling'],
        },
        margin: [10, 4],
      },
      photo: null,
    }
  },
  computed: {
    ...mapGetters('estudio', {
      estudios: 'getEstudios',
    }),
    ...mapGetters('trayectoriaLaboral', {
      trayectoriasLaborales: 'getTrayectorias',
    }),
    tieneTrayectoriaLaboral() {
      return this.trayectoriasLaborales && this.trayectoriasLaborales.length > 0
    },

    getPrimaria() {
      const PRIMARIA_ID = 6
      const primaria = this.estudios.find((estudio) => {
        return estudio.fk_idCatEstudio === PRIMARIA_ID
      })
      if (!primaria) {
        return null
      }
      return primaria
    },
    getSecundaria() {
      const SECUNDARIA_ID = 5
      const secundaria = this.estudios.find((estudio) => {
        return estudio.fk_idCatEstudio === SECUNDARIA_ID
      })
      if (!secundaria) {
        return null
      }
      return secundaria
    },
    getBachillerato() {
      const BACHILLERATO_ID = 4
      const bachillerato = this.estudios.find((estudio) => {
        return estudio.fk_idCatEstudio === BACHILLERATO_ID
      })
      if (!bachillerato) {
        return null
      }
      return bachillerato
    },
    getUniversidad() {
      const UNIVERSIDAD_ID = 3
      const universidad = this.estudios.find((estudio) => {
        return estudio.fk_idCatEstudio === UNIVERSIDAD_ID
      })
      if (!universidad) {
        return null
      }
      return universidad
    },
    tieneTrayectoriaEducativa() {
      return this.getPrimaria || this.getSecundaria || this.getBachillerato || this.getUniversidad
    },
    tieneCursos() {
      return this.cursos && this.cursos.length > 0
    },
    cursosParaMostrar() {
      return this.cursos.map((curso) => {
        const programacion = curso && curso.ProgramacionCurso
        const subcategoria = programacion && programacion.Subcategoria

        return {
          fecha: (programacion && programacion.fechaInicio) || '-',
          nombre: (subcategoria && subcategoria.subcategoria) || '-',
        }
      })
    },
  },
  mounted() {
    if (this.personal && this.personal.idPersonal) {
      this.$store.dispatch('trayectoriaLaboral/fetchByPersonal', this.personal.idPersonal)
    }
  },

  methods: {
    generateReport() {
      const img = new Image()
      img.crossOrigin = 'anonymous'
      img.src = this.personal.foto
      this.photo = img

      this.$refs.cv.generatePdf()
    },
  },
}
</script>
